<mdb-tabset #staticTabs [buttonClass]="'nav-tabs tabs-3 primary-color'" [contentClass]="'card'">
  <mdb-tab heading="Batteries" class="p-3">
      <div class="row" *ngIf="!loaded">
          <div class="col-12">
            <p class="alert alert-info">Loading...</p>
          </div>
      </div>

      <div class="row" *ngIf="loaded">
          <div class="col-12 list-group-item d-flex justify-content-between align-items-center" *ngFor="let item of groupTokenItems">
            {{item.name}} 
            <span *ngIf="!loaded" class="badge badge-primary badge-pill">Loading...</span> 
            <span *ngIf="loaded && !shouldBuyTokens(item)" class="badge badge-primary badge-pill">{{item.quantity}}</span>
            <dac-buy-item-button *ngIf="loaded && shouldBuyTokens(item)" (click)="triggerBuy($event)" [item]="item"></dac-buy-item-button>
          </div>
      </div>
  </mdb-tab>
  <mdb-tab heading="Assessments" class="p-3">
      <div class="row" *ngIf="!loaded">
        <div class="col-12">
          <p class="alert alert-info">Loading...</p>
        </div>
      </div>
      <div *ngIf="loaded" class="row list-group">
          <div class="col-12 list-group-item d-flex justify-content-between align-items-center" *ngFor="let item of tokenItems">
              {{item.name}}
              <span *ngIf="!loaded" class="badge badge-primary badge-pill">Loading...</span> 
              <span *ngIf="loaded && !shouldBuyTokens(item)" class="badge badge-primary badge-pill">{{item.quantity}}</span>
              <button *ngIf="loaded && shouldBuyTokens(item)" class="badge badge-primary badge-pill btn btn-sm btn-primary" alt="Buy Tokens" 
                title="Buy Tokens" [routerLink]="['/admin/shop/']">Buy</button>
          </div>
      </div>
  </mdb-tab>
</mdb-tabset>


// WEBPACK FOOTER //
// ./src/app/admin/assessment-tokens-list/assessment-tokens-list.component.html